// extracted by mini-css-extract-plugin
export default {"sectionartist":"SectionArtist_sectionartist__D7WrW","body":"SectionArtist_body__0+ywU"};